import { z } from 'zod'

export const REQUESTED_TENANT_PARAM = 'tenant'

const TenantId = z.uuid()

export interface BrowserAddress {
  location: Pick<Location, 'href'>
  history: Pick<History, 'state' | 'replaceState'>
}

export const takeRequestedTenant = ({ location, history }: BrowserAddress): string | null => {
  const url = new URL(location.href)
  const requested = url.searchParams.get(REQUESTED_TENANT_PARAM)
  if (requested === null) return null
  url.searchParams.delete(REQUESTED_TENANT_PARAM)
  history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`)
  const parsed = TenantId.safeParse(requested)
  return parsed.success ? parsed.data : null
}
